import { LABELS } from '@/constants/common/message.constants'

import { type PartnerEntity, type CustomerEntity } from '../../aspida/@types'

/**
 * 期日タイプ
 */
export type DueDateType = NonNullable<
  PartnerEntity['dueDateType'] | CustomerEntity['dueDateType']
>

export const DUE_DATE_TYPE = {
  /** 末 */
  END_OF_MONTH: 'END_OF_MONTH',
  /** 日 */
  DAY_OF_MONTH: 'DAY_OF_MONTH'
} as const satisfies Record<DueDateType, DueDateType>

export const DUE_DATE_TYPE_LABEL = {
  [DUE_DATE_TYPE.END_OF_MONTH]: LABELS.DUE_DATE_TYPE_END,
  [DUE_DATE_TYPE.DAY_OF_MONTH]: LABELS.DUE_DATE_TYPE_DAY
} as const satisfies Record<DueDateType, string>

export function getDueDateTypeLabel(type: DueDateType): string {
  return DUE_DATE_TYPE_LABEL[type]
}
